import type { CaseStatus, ClosedReason } from '@taksikortti/shared';
import { StateBadge } from './StateBadge';

export interface StatusBadgeProps {
  status: CaseStatus;
  closedReason?: ClosedReason | null;
}

// Thin wrapper over the unified StateBadge (kept for existing call sites).
export function StatusBadge({ status, closedReason }: StatusBadgeProps) {
  return <StateBadge status={status} closedReason={closedReason ?? null} />;
}
